<template>
<svg
    width="304"
    height="305"
    viewBox="0 0 304 305"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.14"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M171.644 77.1174C187.968 75.1951 185.555 100.242 196.687 112.843C205.518 122.84 216.45 122.029 222.156 134.3C227.308 145.381 209.457 154.153 203.238 164.705C198.397 172.917 197.692 184.254 189.802 189.195C181.946 194.115 171.734 186.559 163.141 189.817C143.443 197.286 127.88 228.852 108.878 219.88C92.3451 212.074 107.936 182.961 113.339 164.655C117.143 151.765 103.884 126.28 114.347 118.443C120.349 113.947 145.885 116.388 155.003 106.755C164.12 97.1222 153.935 79.2029 171.644 77.1174Z"
      fill="#FFDA18"
    />
    <path
      opacity="0.1"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M70.3527 78.8439C96.1947 60.1105 121.375 109.958 151.982 107.949C175.736 106.39 189.826 67.4997 213.219 69.4685C235.668 71.3579 226.292 108.466 236.992 127.479C248.535 147.988 294.381 163.96 277.102 182.974C254.827 207.484 214.301 181.953 184.364 195.143C171.21 200.939 178.432 228.755 164.718 232.49C151.449 236.104 149.01 210.483 135.962 208.325C113.375 204.589 84.1406 231.34 67.6758 216.437C53.6646 203.755 81.1233 178.808 81.5079 159.037C82.0539 130.976 46.5594 96.0921 70.3527 78.8439Z"
      fill="#EE8C32"
    />
    <g clip-path="url(#clip0_4078:17349)">
      <path
        d="M158.381 179.515H204.265C204.265 171.473 197.661 164.963 189.503 164.963H186.913C192.007 158.453 194.812 150.581 194.812 142.284C189.46 142.284 184.755 145.688 183.072 150.709C181.733 154.666 179.489 158.325 176.381 161.389C171.158 166.537 164.295 169.345 157.043 169.345C149.792 169.345 142.885 166.537 137.705 161.389C132.526 156.24 129.634 149.475 129.634 142.327C129.634 135.179 132.482 128.371 137.705 123.265C140.813 120.202 144.525 117.947 148.54 116.67C153.633 115.011 157.086 110.373 157.086 105.097C146.943 105.054 137.49 108.926 130.281 115.989C123.073 123.052 119.188 132.413 119.188 142.284C119.188 150.581 121.95 158.453 127.087 164.963H124.54C116.382 164.963 109.778 171.473 109.778 179.515H155.576C156.05 179.515 156.482 179.557 156.957 179.557C157.432 179.557 157.906 179.557 158.381 179.515Z"
        fill="url(#paint0_linear_4078:17349)"
      />
      <path
        d="M171.633 120.162C174.494 120.162 176.813 117.876 176.813 115.056C176.813 112.236 174.494 109.95 171.633 109.95C168.772 109.95 166.453 112.236 166.453 115.056C166.453 117.876 168.772 120.162 171.633 120.162Z"
        fill="url(#paint1_linear_4078:17349)"
      />
      <path
        d="M185.273 133.31C188.133 133.31 190.453 131.024 190.453 128.204C190.453 125.384 188.133 123.098 185.273 123.098C182.412 123.098 180.093 125.384 180.093 128.204C180.093 131.024 182.412 133.31 185.273 133.31Z"
        fill="url(#paint2_linear_4078:17349)"
      />
      <path
        d="M186.913 164.966C185.92 166.242 184.841 167.434 183.676 168.583C176.856 175.305 167.921 179.177 158.381 179.518H204.222C204.222 171.476 197.618 164.966 189.46 164.966H186.913Z"
        fill="url(#paint3_linear_4078:17349)"
      />
      <path
        d="M157.043 179.56C157.475 179.56 157.863 179.56 158.295 179.518C157.863 179.56 157.475 179.56 157.043 179.56Z"
        fill="url(#paint4_linear_4078:17349)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4078:17349"
        x1="109.918"
        y1="142.417"
        x2="204.406"
        y2="142.417"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00149187" stop-color="#FA8857" />
        <stop offset="0.9976" stop-color="#FFBA2E" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4078:17349"
        x1="166.469"
        y1="115.069"
        x2="176.828"
        y2="115.069"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00149187" stop-color="#FA8857" />
        <stop offset="0.9976" stop-color="#FFBA2E" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_4078:17349"
        x1="180.108"
        y1="128.216"
        x2="190.468"
        y2="128.216"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00149187" stop-color="#FA8857" />
        <stop offset="0.9976" stop-color="#FFBA2E" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_4078:17349"
        x1="158.45"
        y1="172.26"
        x2="204.291"
        y2="172.26"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00149187" stop-color="#FA8857" />
        <stop offset="0.9976" stop-color="#FFBA2E" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_4078:17349"
        x1="157.045"
        y1="179.539"
        x2="158.297"
        y2="179.539"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00149187" stop-color="#FA8857" />
        <stop offset="0.9976" stop-color="#FFBA2E" />
      </linearGradient>
      <clipPath id="clip0_4078:17349">
        <rect
          width="94.4444"
          height="74.5029"
          fill="white"
          transform="translate(109.778 105.057)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  name: 'LogoIcon'
}
</script>
